import { api } from '../DefaultService';
import { ISyncScheduleProps, ISyncStatusProps } from './types';

const ENDPOINT = 'v1/sync-status';

export const getAllSyncStatusesAsync = async (): Promise<
  ISyncStatusProps[]
> => {
  return await api
    .get<ISyncStatusProps[]>(ENDPOINT)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllSyncSchedulesAsync = async (): Promise<
  ISyncScheduleProps[]
> => {
  return await api
    .get<ISyncScheduleProps[]>(`${ENDPOINT}/schedule`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateSyncScheduleAsync = async ({
  serviceName,
  hour,
  minute,
}: ISyncScheduleProps): Promise<ISyncScheduleProps> => {
  return await api
    .put<ISyncScheduleProps>(`${ENDPOINT}/${serviceName}/schedule`, {
      hour,
      minute,
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const triggerSyncNowAsync = async (
  serviceName: string,
): Promise<void> => {
  return await api
    .post(`${ENDPOINT}/${serviceName}/trigger-now`)
    .then(() => undefined)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
